"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * NavigationItem provides interprets individual entries in a TopNav config.
 * Clients of TopNav can choose to pass their own implementation in order to
 * provide custom logic or link types, such as react-isomorphic-router Link
 * components, for their own use cases. This ui common implementaiton provides
 * a reasonable default and a base to work from for clients that need
 * specialized logic.
 */
var NavigationItem = function NavigationItem(_ref) {
  var tab = _ref.tab,
      className = _ref.className,
      onClick = _ref.onClick;

  var _ref2 = tab || {},
      disabled = _ref2.disabled,
      secondary = _ref2.secondary,
      separator = _ref2.separator,
      url = _ref2.url,
      text = _ref2.text,
      openInNewTab = _ref2.openInNewTab,
      active = _ref2.active;

  if (disabled || secondary) return null;
  var item = null;

  if (separator) {
    item = _react["default"].createElement("hr", {
      className: "navSeparator"
    });
  } else {
    var classes = (0, _classnames["default"])(className, {
      active: active
    });
    item = _react["default"].createElement("a", {
      className: classes,
      href: url,
      target: openInNewTab ? '_blank' : '_self',
      onClick: onClick
    }, text);
  }

  return item;
};

NavigationItem.propTypes = {
  tab: _propTypes["default"].shape({
    enabled: _propTypes["default"].bool,
    secondary: _propTypes["default"].bool,
    separator: _propTypes["default"].bool,
    local: _propTypes["default"].bool,
    url: _propTypes["default"].string,
    text: _propTypes["default"].string,
    openInNewTab: _propTypes["default"].bool
  }).isRequired,
  className: _propTypes["default"].oneOf([// NavigationItem's a tag could be styled as a clear link (without hover/contrasting color/under
  // -line styles.
  'clearLink']),
  onClick: _propTypes["default"].func
};
NavigationItem.defaultProps = {
  className: null,
  onClick: _lodash["default"].noop
};
var _default = NavigationItem;
exports["default"] = _default;